import React from "react";

const GoogleSlidesIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5409 0L34.5409 10L29.5409 10.9091L24.5409 10L23.6318 5.45455L24.5409 0Z",
  fill: "#F29900"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5409 10V0H8.17722C6.67041 0 5.44995 1.22045 5.44995 2.72727V37.2727C5.44995 38.7795 6.67041 40 8.17722 40H31.8136C33.3204 40 34.5409 38.7795 34.5409 37.2727V10H24.5409Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9045 15.4545V27.7273H29.0864V15.4545H10.9045ZM26.8136 25.4545H13.1773V17.7273H26.8136V25.4545Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleSlidesIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;